

export const AllToasts = (statusNum,msg,toastx) => {

    if (statusNum === 2) {
      toastx.current.show({ severity: 'error', summary: 'Error', detail:msg , life: 3000 });
      
    }

   if (statusNum === 1) {
        toastx.current.show({ severity: 'success', summary: 'Success', detail:msg, life: 3000 });
      }
  
  }
  